const btnConfirmCreateUser = {
  text: 'Criar Conta'
};

export default btnConfirmCreateUser;
